<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ financialInstitutionName }}</span>
		<app-button
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			>Create new lender</app-button
		>
	</div>
</ng-template>

<ng-template #institutionTemplate let-item>
	<div class="flex">
		<span class="whitespace-nowrap">{{ item.name | capitalize }}</span>
	</div>
</ng-template>

<ng-template #branchTemplate let-item>
	<div class="flex flex-col">
		<div>
			<span
				class="whitespace-nowrap"
				[ngClass]="{ 'font-bold': !item?.name }"
				>{{ item.institutionName | capitalize }}</span
			>
			<span class="ml-3"
				>{{ item.institutionNumber }} - {{ item.transitNumber }}</span
			>
		</div>
		<span class="font-bold" *ngIf="item?.name">{{ item?.name }}</span>
		<span class="whitespace-nowrap text-sm"
			>{{ item?.branchAddress?.street }}, {{ item?.branchAddress?.city }}</span
		>
	</div>
</ng-template>

<div>
	<div [@openClose] *ngIf="mortgageeType === mortgageeTypes.INSTITUTION">
		<div class="my-4">Search to add a financial institution</div>

		<app-auto-complete
			(onSelect)="onSelect($event)"
			placeholder="Search to add a lender"
			[itemGroups]="[
				{
					items: [{ value: 'createNew' }],
					template: createNewTemplate,
					type: dropdownSelect.CREATE,
				},
				{
					items: financialInstitutions,
					template: institutionTemplate,
					title: 'Institutions',
					noResultsMessage: 'No lender found',
					type: dropdownSelect.SELECT_INSTITUTION,
				},
			]"
			[(ngModel)]="financialInstitutionName"
			name="dual-dropdown-1"
			(debounce)="search($event)"
			[loading]="loading"
			width="w-full"
		>
		</app-auto-complete>

		<div class="mt-4">Or select a leading bank</div>
		<div class="flex gap-3 py-5 flex-wrap">
			<ng-container *ngFor="let bank of lenders">
				<div
					class="p-2 cursor-pointer hover:shadow-md flex items-center justify-center w-24"
					(click)="setLeadingBank(bank.institutionId)"
				>
					<img [src]="'/assets/images/banks/' + bank.logo" />
				</div>
			</ng-container>
		</div>
	</div>
	<div [@openClose] *ngIf="mortgageeType === mortgageeTypes.COMPUTERSHARE">
		<div [@openClose]>
			<div class="my-4">Search to add a Computershare lender</div>
			<app-financial-institution-branch-search
				[financialInstitution]="financialInstitution"
				[showDischargeFields]="showDischargeFields"
				[fileType]="fileType"
				[mortgageeType]="mortgageeType"
				[autoComplete]="true"
				(onSelectedBranch)="onSelectComputerShareBranch($event)"
			>
			</app-financial-institution-branch-search>

			<div class="mt-4">Or select a leading lender</div>
			<div class="flex gap-3 py-5 flex-wrap">
				<ng-container *ngFor="let lender of popularCSLenders">
					<div
						class="p-2 cursor-pointer hover:shadow-md flex items-center justify-center w-24"
						(click)="setLeadingCSLender(lender.institutionId)"
					>
						<img [src]="'/assets/images/banks/' + lender.logo" />
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
